import { selectIsLoadingDynamicsExportPreferences } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamics/exportSelectors";
import { selectIsLoadingHsExportPreferences } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspot/exportSelectors";
import { selectIsLoadingSfExportPreferences } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { useSelector } from "react-redux";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";

const selectorsConfig = {
    hubspot: selectIsLoadingHsExportPreferences,
    salesforce: selectIsLoadingSfExportPreferences,
    dynamics: selectIsLoadingDynamicsExportPreferences,
};

export const useIsLoadingExportPreferences = () => {
    const { integrationName } = getIntegrationNameFromUrl();
    const selectIsLoading = selectorsConfig[integrationName as Integration];
    return useSelector(selectIsLoading);
};
